// 根据域名初始确认企业信息接口
export const CMPYINFOBYREQDOMAIN = 'CmpyinfoByReqdomain'
// 获取企业的基础营销配置信息getSysmarinfo
export const GETSYSMARINFO = 'getSysmarinfo'
//  获取企业的公共服务基础配置信息接口
export const GETPUBCONFIGINFO = 'getPubconfiginfo'
//  微信登录/注册初始化接口
export const INITBYWX = 'InitByWX'
// 获取banner数据接口
export const BANNERLIST = 'BannerList'
// 获取全国门店数据接口
export const GETSTORELIST = 'getStoreList'
// 获取公告数据接口
export const BBS = 'Bbs'
// 营销优惠券列表查询接口
export const COUPONPROMOTIONLIST = 'couponpromotionList'
// 获取精心推荐商品列表
export const GOODSLISTFORRECOMMEND = 'getGoodsListForRecommend'
// 获取限时秒杀指定场次的商品列表
export const GETGOODSLISTFORSECKILL = 'getGoodsListForSeckill'
// 获取首页送礼优选/发现好货商品列表
export const GETGOODSLISTFORPUSH = 'getGoodsListForPush'
// 获取送礼优选主题
export const GETTHEMEINFOLIST = 'getThemeinfoList'
// 获取首页促销商品列表
export const GETGOODSLISTFOREXPRESALE = 'getGoodsListForExpresale'
// 获取商品分类列表
export const GETCLASSIFYLIST = 'getClassifyList'
// 获取实物商品列表
export const GETGOODSLIST = 'getGoodsList'
// 获取商品推荐列表
export const GETGOODSLISTFORHOT = 'getGoodsListForHot'
// 获取我的足迹列表
export const GETBROWSEINFOLIST = 'getBrowseinfoList'
// 添加常规商品浏览足迹
export const ADDBROWSEINFO = 'addBrowseinfo'
// 获取搜索推荐关键词
export const GETSEARCHKEYWORDS = 'getSearchKeywords'
// 获取商品信息详情
export const GETGOODSINFODET = 'getGoodsinfoDet'
// 获取商品描述详情
export const GETGOODSDESC = 'getGoodsDesc'
// 获取商品指定规格库存
export const GETGOODSINVINFO = 'getGoodsinvinfo'
// 获取商品买家印象
export const GETIMPRESSINFOS = 'getImpressinfos'
// 获取商品评价统计
export const GETGOODSEVASTATISTICS = 'getGoodsEvaStatistics'
// 获取商品评价记录列表
export const GETGOODSEVARECORDSLIST = 'getGoodsevarecordsList'
// 获取商品参加的促销活动
export const GETGOODSPROMOTIONS = 'getGoodsPromotions'
// 获取商品参加的优惠套餐
export const GETGOODSDISPACKAGE = 'getGoodsDisPackage'
// 获取优惠套餐详情
export const GETPACKAGEDET = 'getPackageDet'
// 新增降价通知
export const ADDDOWNNOTICE = 'addDownNotice '
// 账号登录接口
export const LOGINBYACCOUNT = 'loginByAccount'
// 账号注册接口
export const REGISTERBYACCOUNT = 'registerByAccount'
// 注册/绑定发送验证码接口
export const GETCHECKCODETOREGISTER = 'getCheckcodeToRegister'
// 微信登录/注册初始化接口
export const LOGINORREGISTERINITBYWX = 'loginOrRegisterInitByWX'
// 微信登录/注册接口
export const LOGINORREGISTERBYWX = 'loginOrRegisterByWX'
// 手机号码/邮箱确认绑定接口 微信登录成功时弹框验证
export const BINDMPHONE = 'bindMphone'
// 验证码有效性确认接口（密码找回）
export const CHECKVALCHECKCODE = 'checkValCheckcode'
// 密码找回发送手机验证码接口（密码找回）
export const CHECKCODETOFINDPWD = 'getCheckcodeToFindPwd'
// 确认账号有效性接口（密码找回）
export const CHECKACCOUNTVAL = 'checkAccountVal'
// 重设密码接口（密码找回）
export const UPDATEPWD = 'updatePwd'
// 账号安全级别校验接口
export const CHECKACCOUNTSECURITYLEVEL = 'checkAccountSecurityLevel'
// 获取会员信息详情
export const GETMEMBERINFO = 'getMemberinfo'
// 消费者意见建议提交
export const ADDSUGGESTIONS = 'addSuggestions'
// 消费者理赔申请 addReturnapplication
export const ADDRETURNAPPLICATION = 'addReturnapplication'
// 省市区三级联动查询接口
export const GETADDRESS = 'getAddress'
// 省市区三级联动查询接口(shi)
export const GETADDRESSCITY = 'getAddressCity'
// 省市区三级联动查询接口(qu)
export const GETADDRESSAREA = 'getAddressArea'
// 已登录用户发送验证码接口
export const GETCHECKCODEBYLOGINEDMEMBERINFO = 'getCheckcodeByLoginedMemberinfo'
// 已登录用户验证码有效性接口
export const CHECKVALCHECKCODEBYLOGINEDMEMBERINFO = 'checkValCheckcodeByLoginedMemberinfo'
// 已登录用户密码修改接口
export const UPDATEPWDBYLOGINEDMEMBERINFO = 'updatePwdByLoginedMemberinfo'
// 已登录用户微信绑定接口
export const BINDBYWX = 'bindByWX'
// 已登录用户微信绑定取消接口
export const UNBINDBYWX = 'unbindByWX'
// 个人信息
export const UPDATEBASEMEMBERINFO = 'updateBaseMemberinfo'
// 获取企业基础信息
export const GETBASICCMPYINFO = 'getBasiccmpyinfo'
// 新增提问记录
export const ADDFAQ = 'addFaq'
//  获取常见问题/提问记录列表
export const GETFAQLIST = 'getFaqList'
// 地址信息
// 省市区三级联动查询接口getAddrinfo
export const GETADDRINFO = 'getAddrinfo'
//  收货人信息列表查询接口
export const GETADDRLIST = 'getAddrList'
// 收货人信息详情查询接口
export const GETADDRDET = 'getAddrDet'
// 收货人信息删除接口
export const DELETEADDR = 'deleteAddr'
// 收货人信息新增接口
export const ADDADDR = 'addAddr'
// 收货人信息更新接口
export const UPDATEADDR = 'updateAddr'
// 更新指定收货人信息为默认地址
export const UPDATEADDRISDEF = 'updateAddrIsDef'
// 我的常购商品列表,包括实物商品、兑换礼券、充值卡
export const GETOFTENBUYGOODSLIST = 'getOftenbuygoodsList'
// 我的资产
// 账户余额获取接口
export const GETACCOUNTBALANCE = 'getAccountBalance'
// 可用券卡数量统计接口
export const GETSTATISTICALBYCARD = 'getStatisticalByCard'
// 资产变更明细
export const GETMARDETAIL = 'getMardetail'
// 资产指定区间明细统计
export const GETSTATISTICALBYMARDETAIL = 'getStatisticalByMardetail'
// 充值卡充值接口
export const ADDCARDTORECHARGE = 'addCardToRecharge'
// 我的卡包
export const GETCARDBAG = 'getCardbag'
// 查询券卡多选专区详情
export const GETOPTGOODSINFOOFCODE = 'getOptgoodsinfoOfCode'
// 卡包券卡动态统计
export const GETSTATISTICALBYCARDBAG = 'getStatisticalByCardbag'
// 根据会员编号查询会员简单信息，主要用于查询券卡送礼人和收礼人简单信息
export const GETBASEMEMBERINFO = 'getBaseMemberinfo'
// 卡券加入卡包接口，主要用于兑换礼券和充值卡
export const ADDCODETOCARDBAG = 'addCodeToCardbag'
// 我的优惠券
export const GETCOUPONOFCARDBAG = 'getCouponOfCardbag'
// 优惠券
// 营销优惠券列表查询接口
export const GETCOUPONPROMOTIONLIST = 'getCouponpromotionList'
// 营销优惠券领取接口
export const ADDCOUPON = 'addCoupon'
// 关注商品列表
export const GETATTENTIONGOODSLIST = 'getAttentionGoodsList'
// 关注商品
export const ATTENTIONCARTITEM = 'attentionCartItem'
// 取消关注商品
export const CANCLEATTENTIONCARTITEM = 'cancleAttentionCartItem'
// 加入购物车
export const ADDCARTITEM = 'addCartItem'
//  获取购物车列表
export const GETSHOPPINGCART = 'getShoppingCart'
// 从购物车获取结算信息
export const GETSETTLEMENTFORM = 'getSettlementFromShoppingCart'
// 从购物车移除商品
export const REMOVECARTITEM = 'removeCartItem'
// 变更购物车中商品购买数量
export const CHANGEQUANTITY = 'changeQuantity'
// 变更购物车中商品的选中状态
export const SELECTCARTITEM = 'selectCartItem'
// 变更购物车中商品参加的促销活动
export const UPDATESALESPROMOTION = 'updateSalesPromotion'
// 新增降价通知
export const ADDDOWNNOTTICE = 'addDownNotice'
// 订单
// 订单提交
export const ADDORDERINFO = 'addOrderinfo'
// 获取订单付款信息，包括付款信息初始化和校验付款结果
export const GETORDERPAYINFO = 'getOrderpayinfo'
// 获取微信付款码URL
export const GETWXPAYURL = 'getWxPayUrl'
// 订单状态归类统计
export const GETSTATISTICALBYORDERSTATE = 'getStatisticalByOrderstate'
// 我的订单列表数据接口
export const GETORDERINFOLIST = 'getOrderinfoList'
// 订单详情基础数据接口，包含订单基本信息、收货人信息，如果是预约自提订单，还包含预约自提门店信息
export const GETORDERINFOBASEDET = 'getOrderinfoBaseDet'
// 订单详情商品清单数据接口
export const GETORDERINFOGOODSDET = 'getOrderinfoGoodsDet'
// 订单配送信息数据接口
export const GETORDERINFOEXPDET = 'getOrderinfoExpDet'
// 订单付款信息数据接口
export const GETORDERINFOPAYDET = 'getOrderinfoPayDet'
// 订单开票信息数据接口
export const GETORDERINFOINVOICEDET = 'getOrderinfoInvoiceDet'
// 订单参与营销活动数据接口
export const GETORDERINFOPROMOTIONDET = 'getOrderinfoPromotionDet'
// 订单取消
export const CANCELORDERINFO = 'cancelOrderinfo'
// 券卡查询接口
export const QUERYCODEINFO = 'queryCodeinfo'
// 申请送货、预约自提调用该接口进行初始化
export const EXCHANGEINIT = 'exchangeInit'
// 申请送货/预约自提券卡验证接口
export const EXCHANGECHECKCODE = 'exchangeCheckCode'
// 申请送货/预约自提券卡验证接口
export const SUBCHOOSEGOODS = 'subChooseGoods'
// 申请送货/预约自提券卡验证接口
export const UPDATECHOOSEGOODS = 'updateChooseGoods'
// 期望发货日期获取接口
export const GET_EXCHANGEORDERRECVDATESETPARM = 'getExchangeOrderRecvdateSetParm'
// 企业的基订单和发货配置信息
export const GETPUBORDPRINTINFO = 'getPubordprintinfo'


// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/store/modules/mutation_type.js